export const plus = {
  plus: {
    width: 448,
    height: 448,
    d: 'M416,176L272,176L272,32C272,14.33 257.67,0 240,0L208,0C190.33,0 176,14.33 176,32L176,176L32,176C14.33,176 0,190.33 0,208L0,240C0,257.67 14.33,272 32,272L176,272L176,416C176,433.67 190.33,448 208,448L240,448C257.67,448 272,433.67 272,416L272,272L416,272C433.67,272 448,257.67 448,240L448,208C448,190.33 433.67,176 416,176Z',
  },
};

export const minus = {
  minus: {
    width: 448,
    height: 448,
    d: 'M416,176L32,176C14.33,176 0,190.33 0,208L0,240C0,257.67 14.33,272 32,272L416,272C433.67,272 448,257.67 448,240L448,208C448,190.33 433.67,176 416,176Z',
  },
};

export const expand = {
  expand: {
    width: 448,
    height: 448,
    d: 'M0,148L0,24C0,10.7 10.7,0 24,0L148,0C154.6,0 160,5.4 160,12L160,52C160,58.6 154.6,64 148,64L64,64L64,148C64,154.6 58.6,160 52,160L12,160C5.4,160 0,154.6 0,148ZM288,12L288,52C288,58.6 293.4,64 300,64L384,64L384,148C384,154.6 389.4,160 396,160L436,160C442.6,160 448,154.6 448,148L448,24C448,10.7 437.3,0 424,0L300,0C293.4,0 288,5.4 288,12ZM436,288L396,288C389.4,288 384,293.4 384,300L384,384L300,384C293.4,384 288,389.4 288,396L288,436C288,442.6 293.4,448 300,448L424,448C437.3,448 448,437.3 448,424L448,300C448,293.4 442.6,288 436,288ZM160,436L160,396C160,389.4 154.6,384 148,384L64,384L64,300C64,293.4 58.6,288 52,288L12,288C5.4,288 0,293.4 0,300L0,424C0,437.3 10.7,448 24,448L148,448C154.6,448 160,442.6 160,436Z',
  },
};

export const questionMark = {
  questionMark: {
    width: 16,
    height: 16,
    d: 'm 8.93,6.588 -2.29,0.287 -0.082,0.38 0.45,0.083 c 0.294,0.07 0.352,0.176 0.288,0.469 l -0.738,3.468 c -0.194,0.897 0.105,1.319 0.808,1.319 0.545,0 1.178,-0.252 1.465,-0.598 L 8.919,11.58 c -0.2,0.176 -0.492,0.246 -0.686,0.246 -0.275,0 -0.375,-0.193 -0.304,-0.533 z M 9,4.5 a 1,1 0 1 1 -2,0 1,1 0 0 1 2,0 z M 8,15 A 7,7 0 1 1 8,1 7,7 0 0 1 8,15 Z m 0,1 A 8,8 0 1 0 8,0 8,8 0 0 0 8,16 Z',
  },
};

export const shift = {
  shift: {
    width: 512,
    height: 512,
    d: 'M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z',
  },
};

export const twitter = {
  twitter: {
    width: 512,
    height: 512,
    d: 'M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z',
  },
};

export const copy = {
  copy: {
    width: 448,
    height: 512,
    d: 'M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z',
  },
};